import React, { Component } from 'react'
import ListItem from '~/components/ListItem'
import { onUserAuth } from '~/redux/user/helpers'
import { fetchHistory, deleteHistory } from '~/redux/uservideo/helpers'
import RequireAuth from '~/components/RequireAuth'
import withInfiniteScrolling from '~/tools/withInfiniteScrolling'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'

class History extends Component {
  state = {
    deleteAllModal: false,
    page: 1
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.user && !this.state.user) {
      this.setState({
        deleteAllModal: false,
      })
    }
  }

  toggleModal = () => {
    this.setState({ deleteAllModal: !this.state.deleteAllModal })
  }

  clear = () => {
    deleteHistory().then(response => {
      if(response.status === 200) {
        this.props.setWrappedState({ items: [] })
        this.setState({ deleteAllModal: !this.state.deleteAllModal })
      }
    });
  }

  deleteItem = (item) => {
    deleteHistory(item.id)
    .then(response => {
      if(response.status ===  200) {
        this.props.setWrappedState({
          items: this.props.items.filter(l => l.id !== item.id),
        })
      }
    })
  }

  fetchData() {
    return new Promise((resolve, reject) => {
      return onUserAuth(user => {
        if (user) {
          return fetchHistory(user.userId, this.state.page).then(response => {
            console.log(response)
            const videos = response.map(item => item = item.contentResponse.gist)
            this.setState({ page: this.state.page + 1 })
            resolve(videos)
          })
        }
      })
    })
  }
  
  render() {
    console.log(this.props)
    return(
      !window.SERVER_SIDE_RENDERING && (
        <RequireAuth user={this.state.user}>
          <ListItem 
            trayTitle={this.props.data.title || 'History'} 
            deleteItem={this.deleteItem} 
            toggleModal={this.toggleModal} 
            clear={this.clear} 
            header="History"
            deleteAllModal={this.state.deleteAllModal}
            {...this.props}
            {...this.state}
          />
        </RequireAuth>
      )
    )
  }
}

connect(History, (state) => ({ user: state.user }), userStore)

export default withInfiniteScrolling(History);
